<template>
    <v-form>
        <v-row>
            <v-col>
                <v-btn
                class="primary"
                :loading="isLoading"
                @click="submitData"
                >เรียกขนส่ง</v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>
<script>
import { asyncPost } from '@/helpers/asyncAxios'
import errorParser from '@/plugins/errorparser'
import {
  integerValidator,
  lengthValidator,
  maxLengthValidator,
  maxValueValidator,
  minLengthValidator,
  minValueValidator,
  numberValidator,
  required,
  requiredIf,
} from '@core/utils/validation'
export default {
  props: ['order', 'providers'],
  data() {
    return {
      isLoading: false,
      formData: {},
      validators: {
        integerValidator,
        lengthValidator,
        maxLengthValidator,
        maxValueValidator,
        minLengthValidator,
        minValueValidator,
        numberValidator,
        required,
        requiredIf,
      },
    }
  },
  methods: {
    async submitData() {
      this.isLoading = true

      try {
        await asyncPost('/saleorder/pendingdelivery/' + this.order.id + '/tiktok/pickup', this.formData)

        this.$emit('done')
      } catch (error) {
        console.log(error)
        this.$root.showCommonDialog('มีปัญหา', errorParser(error))
      }

      this.isLoading = false
    },
  },
}
</script>
